import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, roleHome } from "@/context/AuthContext";
import { Handshake, Building2, Loader2, ArrowRight } from "lucide-react";

export default function PortalLaunch() {
  const { user, loading } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && user) nav(roleHome(user.role), { replace: true });
  }, [loading, user, nav]);

  return (
    <div className="min-h-screen bg-[#0B1220] text-white flex flex-col items-center justify-center px-6" data-testid="portal-launch">
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none" style={{ backgroundImage: "radial-gradient(rgba(255,255,255,0.9) 1px, transparent 1px)", backgroundSize: "22px 22px" }} />
      <img src="/pwa/icon-192.png" alt="Connexis" className="size-20 rounded-3xl border border-white/10 shadow-2xl shadow-black/50" />
      {loading || user ? (
        <div className="mt-8 flex items-center gap-2 text-white/50 text-[13px]">
          <Loader2 className="size-4 animate-spin" /> Opening your portal…
        </div>
      ) : (
        <div className="relative mt-8 w-full max-w-sm text-center">
          <div className="text-[11px] font-semibold tracking-[0.24em] uppercase text-[#7da9ff]">Connexis Group</div>
          <h1 className="mt-2 text-[24px] font-semibold tracking-[-0.01em]">Welcome back, partner.</h1>
          <p className="mt-1.5 text-[13px] text-white/45">Pick your portal to sign in.</p>
          <div className="mt-7 space-y-3">
            <Link to="/introducer/login" className="flex items-center gap-3 rounded-2xl border border-white/10 bg-white/[0.04] hover:bg-white/[0.08] transition-colors p-4 text-left" data-testid="launch-introducer">
              <span className="grid place-items-center size-10 rounded-xl bg-[#0055FF]/15 border border-[#0055FF]/30"><Handshake className="size-4.5 text-[#7da9ff]" /></span>
              <span className="flex-1">
                <span className="block text-[14.5px] font-semibold">Introducer portal</span>
                <span className="block text-[11.5px] text-white/40">Submit deals · track commission</span>
              </span>
              <ArrowRight className="size-4 text-white/30" />
            </Link>
            <Link to="/lender/login" className="flex items-center gap-3 rounded-2xl border border-white/10 bg-white/[0.04] hover:bg-white/[0.08] transition-colors p-4 text-left" data-testid="launch-lender">
              <span className="grid place-items-center size-10 rounded-xl bg-emerald-400/10 border border-emerald-400/25"><Building2 className="size-4.5 text-emerald-300" /></span>
              <span className="flex-1">
                <span className="block text-[14.5px] font-semibold">Lender desk</span>
                <span className="block text-[11.5px] text-white/40">Review deal flow · fund deals</span>
              </span>
              <ArrowRight className="size-4 text-white/30" />
            </Link>
          </div>
          <Link to="/login" className="mt-6 inline-block text-[12px] text-white/35 hover:text-white/60 transition-colors" data-testid="launch-team">Connexis team sign-in →</Link>
        </div>
      )}
    </div>
  );
}
